import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.map.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import addCustomizableProductToCartMutation from '~/graphql/cart/addCustomizableProductToCart.gql';
import addGiftCardToCartMutation from '~/graphql/cart/addGiftCardToCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import addSellerIdToCartMutation from '~/graphql/cart/addSellerIdToCart.gql';
import cartQuery from '~/graphql/cart/cart.gql';
import cartTotalQuantityQuery from '~/graphql/cart/cartTotalQuantity.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import mergeOrderFormToCartMutation from '~/graphql/cart/mergeOrderFormToCart.gql';
import minicartQuery from '~/graphql/cart/minicart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

// Some prettify waiting Apollo's refacto for links use.
// https://www.apollographql.com/docs/react/api/link/introduction/
function getHeaders(token) {
  return {
    Authorization: token ? "Bearer ".concat(token) : ''
  };
}
function fetchCartTotalQuantity(_x, _x2) {
  return _fetchCartTotalQuantity.apply(this, arguments);
}
function _fetchCartTotalQuantity() {
  _fetchCartTotalQuantity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, _ref) {
    var reference, token, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          reference = _ref.reference, token = _ref.token;
          _context.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            query: cartTotalQuantityQuery,
            errorPolicy: 'all',
            fetchPolicy: 'network-only',
            context: {
              headers: getHeaders(token)
            },
            variables: {
              reference: reference
            }
          });
        case 3:
          data = _context.sent;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCartTotalQuantity.apply(this, arguments);
}
function fetchCart(_x3, _x4) {
  return _fetchCart.apply(this, arguments);
}
function _fetchCart() {
  _fetchCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, _ref2) {
    var reference, token;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          reference = _ref2.reference, token = _ref2.token;
          _context2.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            query: minicartQuery,
            errorPolicy: 'all',
            fetchPolicy: 'network-only',
            context: {
              headers: getHeaders(token)
            },
            variables: {
              reference: reference
            }
          });
        case 3:
          return _context2.abrupt("return", {
            data: {
              minicart: {
                items: [],
                quantity: 0
              }
            }
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchCart.apply(this, arguments);
}
function getOrderFormPaymentEligibility(_x5, _x6) {
  return _getOrderFormPaymentEligibility.apply(this, arguments);
}
function _getOrderFormPaymentEligibility() {
  _getOrderFormPaymentEligibility = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, _ref3) {
    var maskedQuoteId, token, _yield$context$app$ap, data, isElegible;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          maskedQuoteId = _ref3.maskedQuoteId, token = _ref3.token;
          _context3.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            query: cartQuery,
            errorPolicy: 'all',
            fetchPolicy: 'network-only',
            context: {
              headers: getHeaders(token)
            },
            variables: {
              reference: maskedQuoteId
            }
          });
        case 3:
          _yield$context$app$ap = _context3.sent;
          data = _yield$context$app$ap.data;
          isElegible = [];
          data.cart.groupedItems.forEach(function (el) {
            isElegible.push(el.items.reduce(function (acc, item) {
              acc.push(item.product.buyable);
              return acc;
            }, []));
          });
          return _context3.abrupt("return", isElegible.flat().every(function (value) {
            return value === true;
          }));
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getOrderFormPaymentEligibility.apply(this, arguments);
}
function gethasVpProductInCart(_x7, _x8, _x9) {
  return _gethasVpProductInCart.apply(this, arguments);
}
function _gethasVpProductInCart() {
  _gethasVpProductInCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, token, cartToken) {
    var _data$cart;
    var _yield$context$app$ap2, data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return context.app.apolloProvider.defaultClient.query({
            query: cartQuery,
            errorPolicy: 'all',
            fetchPolicy: 'network-only',
            context: {
              headers: getHeaders(token)
            },
            variables: {
              isPrivateSales: true,
              reference: cartToken
            }
          });
        case 2:
          _yield$context$app$ap2 = _context4.sent;
          data = _yield$context$app$ap2.data;
          return _context4.abrupt("return", data === null || data === void 0 ? void 0 : (_data$cart = data.cart) === null || _data$cart === void 0 ? void 0 : _data$cart.groupedItems.reduce(function (acc, groupedItem) {
            return [].concat(_toConsumableArray(acc), _toConsumableArray(groupedItem === null || groupedItem === void 0 ? void 0 : groupedItem.items.map(function (el) {
              var _el$product, _el$product$price;
              return el === null || el === void 0 ? void 0 : (_el$product = el.product) === null || _el$product === void 0 ? void 0 : (_el$product$price = _el$product.price) === null || _el$product$price === void 0 ? void 0 : _el$product$price.isPrivateSales;
            })));
          }, []).some(Boolean));
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _gethasVpProductInCart.apply(this, arguments);
}
function createCart(_x10, _x11) {
  return _createCart.apply(this, arguments);
}
function _createCart() {
  _createCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context, token) {
    var _yield$context$app$ap3, data;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: createNewCartMutation,
            context: {
              headers: getHeaders(token)
            }
          });
        case 2:
          _yield$context$app$ap3 = _context5.sent;
          data = _yield$context$app$ap3.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _createCart.apply(this, arguments);
}
function addCart(_x12, _x13) {
  return _addCart.apply(this, arguments);
}
function _addCart() {
  _addCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(context, _ref4) {
    var token, cart, reference, quantity, offer, response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          token = _ref4.token, cart = _ref4.cart, reference = _ref4.reference, quantity = _ref4.quantity, offer = _ref4.offer;
          _context6.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: addProductsToCartMutation,
            context: {
              headers: getHeaders(token)
            },
            variables: {
              cart: cart,
              products: [_objectSpread({
                reference: reference,
                quantity: quantity
              }, offer && {
                offer: offer
              })]
            }
          });
        case 3:
          response = _context6.sent;
          return _context6.abrupt("return", response);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _addCart.apply(this, arguments);
}
function addCartCustomizable(_x14, _x15) {
  return _addCartCustomizable.apply(this, arguments);
}
function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, _ref5) {
    var cart, token, payload, _yield$context$app$ap4, data;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          cart = _ref5.cart, token = _ref5.token, payload = _ref5.payload;
          _context7.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: addCustomizableProductToCartMutation,
            context: {
              headers: getHeaders(token)
            },
            variables: {
              cart: cart,
              reference: payload
            }
          });
        case 3:
          _yield$context$app$ap4 = _context7.sent;
          data = _yield$context$app$ap4.data;
          return _context7.abrupt("return", data);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _addCartCustomizable.apply(this, arguments);
}
function updateCart(_x16, _x17) {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(context, _ref6) {
    var token, cart, reference, quantity, _yield$context$app$ap5, data;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          token = _ref6.token, cart = _ref6.cart, reference = _ref6.reference, quantity = _ref6.quantity;
          _context8.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateCartMutation,
            context: {
              headers: getHeaders(token)
            },
            variables: {
              cart: cart,
              items: [{
                reference: reference,
                quantity: quantity
              }]
            }
          });
        case 3:
          _yield$context$app$ap5 = _context8.sent;
          data = _yield$context$app$ap5.data;
          return _context8.abrupt("return", data);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _updateCart.apply(this, arguments);
}
function addGiftCardToCart(_x18, _x19) {
  return _addGiftCardToCart.apply(this, arguments);
}
function _addGiftCardToCart() {
  _addGiftCardToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(context, _ref7) {
    var cart, senderName, senderEmail, recipientName, recipientEmail, price, design, message, recaptchaToken, token, response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          cart = _ref7.cart, senderName = _ref7.senderName, senderEmail = _ref7.senderEmail, recipientName = _ref7.recipientName, recipientEmail = _ref7.recipientEmail, price = _ref7.price, design = _ref7.design, message = _ref7.message, recaptchaToken = _ref7.recaptchaToken, token = _ref7.token;
          _context9.next = 3;
          return context.defaultClient.mutate({
            mutation: addGiftCardToCartMutation,
            errorPolicy: 'all',
            context: {
              headers: getHeaders(token)
            },
            variables: {
              cart: cart,
              senderName: senderName,
              senderEmail: senderEmail,
              recipientName: recipientName,
              recipientEmail: recipientEmail,
              price: price,
              design: design,
              message: message,
              recaptchaToken: recaptchaToken
            }
          });
        case 3:
          response = _context9.sent;
          return _context9.abrupt("return", response);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _addGiftCardToCart.apply(this, arguments);
}
function addSellerIdToCart(_x20, _x21) {
  return _addSellerIdToCart.apply(this, arguments);
}
function _addSellerIdToCart() {
  _addSellerIdToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(context, _ref8) {
    var cartToken, sellerId, token, _yield$context$app$ap6, data;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          cartToken = _ref8.cartToken, sellerId = _ref8.sellerId, token = _ref8.token;
          _context10.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: addSellerIdToCartMutation,
            variables: {
              cartToken: cartToken,
              sellerId: sellerId
            },
            context: {
              headers: getHeaders(token)
            }
          });
        case 3:
          _yield$context$app$ap6 = _context10.sent;
          data = _yield$context$app$ap6.data;
          return _context10.abrupt("return", data.addSellerIdToCart);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _addSellerIdToCart.apply(this, arguments);
}
function mergeOrderFormToCart(_x22, _x23) {
  return _mergeOrderFormToCart.apply(this, arguments);
}
function _mergeOrderFormToCart() {
  _mergeOrderFormToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(defaultClient, orderFormId) {
    var _yield$defaultClient$, data;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return defaultClient.mutate({
            mutation: mergeOrderFormToCartMutation,
            variables: {
              orderFormId: orderFormId
            }
          });
        case 2:
          _yield$defaultClient$ = _context11.sent;
          data = _yield$defaultClient$.data;
          return _context11.abrupt("return", data.mergeOrderFormToCart);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _mergeOrderFormToCart.apply(this, arguments);
}
export { addCart, addCartCustomizable, addGiftCardToCart, addSellerIdToCart, createCart, fetchCart, fetchCartTotalQuantity, getOrderFormPaymentEligibility, mergeOrderFormToCart, updateCart, gethasVpProductInCart };